export default "__VITE_ASSET__D940aU1q__"